import * as React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DayPicker } from 'react-day-picker'
import { cn } from '@/lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

export function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        root: 'relative',
        months: 'flex flex-col gap-4 sm:flex-row',
        month: 'flex flex-col gap-4',
        month_caption: 'flex h-9 items-center justify-center',
        caption_label: 'text-body-sm font-semibold text-foreground',
        nav: 'absolute inset-x-3 top-3 z-10 flex h-9 items-center justify-between',
        button_previous:
          'inline-flex h-8 w-8 items-center justify-center rounded-md border border-input bg-card text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        button_next:
          'inline-flex h-8 w-8 items-center justify-center rounded-md border border-input bg-card text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        month_grid: 'w-full border-collapse',
        weekdays: 'flex',
        weekday: 'w-9 text-caption font-medium text-muted-foreground',
        weeks: '',
        week: 'mt-2 flex w-full',
        day: 'p-0 text-center',
        day_button:
          'inline-flex h-9 w-9 items-center justify-center rounded-md text-body-sm font-normal transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        selected:
          '[&>button]:bg-primary [&>button]:text-primary-foreground [&>button:hover]:bg-primary',
        today: '[&>button]:font-semibold [&>button]:text-primary',
        outside: 'text-muted-foreground [&>button]:text-muted-foreground',
        disabled: 'opacity-50 [&>button]:pointer-events-none',
        hidden: 'invisible',
        range_start: '[&>button]:bg-primary [&>button]:text-primary-foreground',
        range_end: '[&>button]:bg-primary [&>button]:text-primary-foreground',
        range_middle: '[&>button]:bg-accent [&>button]:text-accent-foreground',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, ...chevronProps }) =>
          orientation === 'left' ? (
            <ChevronLeft className="h-4 w-4" {...chevronProps} />
          ) : (
            <ChevronRight className="h-4 w-4" {...chevronProps} />
          ),
      }}
      {...props}
    />
  )
}
